export default __webpack_public_path__ + "static/media/customer-survey-animate.0b55087c.svg";